// 无线埋点上报
import { QUEUE } from '../types';
import { InitParams, ReportParams, ClickParams, WXLOG } from './types';
import { Queue, loadJS, isSussKey, isString, getContext } from '../helpers';
import { wxSdkUrl } from './utils/constant';
import platforms from './platforms';
import { splitParams } from './utils';
import getPageType from '../vueInstance/getPageType';

export default class Log implements WXLOG {
    initStatus: boolean = false; // 无线埋点初始化是否完成
    //  全局初始化参数
    initParams: InitParams = {}; // 初始化默认值
    // 无线埋点队列
    queue: QUEUE = new Queue();
    constructor(params: InitParams) {
        this.init(params);
    }
    // 页面初始化
    init(params: InitParams) {
        try {
            // 初始化公共参数
            this.initParams = params;

            // wuba、ganji端检测，bizLine参数必传
            if (getContext() === 'wuba' || getContext() === 'ganji') {
                if (!params.bizLine) {
                    // TODO 添加埋点记录失败的数据，后续需要下线
                    window.ZPAPP &&
                        window.ZPAPP.invoke('job-weblog', {
                            pageType: 'zp-weblog',
                            actionType: 'bizLine-error',
                            extJson: {
                                url: window.location.href,
                                referer: document.referrer
                            }
                        });
                    throw new Error('bizLine必填！');
                }
            }

            // 初始化成功回调
            const initSuccess = () => {
                console.log('【weblog-wx】无线埋点初始化完成');
                this.initStatus = true;
                this.queueReport();
            };

            // 根据平台类型执行不同检测逻辑
            if (getContext() === 'pc' || getContext() === 'm' || getContext() === 'miniProgram') {
                // if (!window.clickLog) {
                //     // 未加载成功,手动添加SDK
                //     return loadJS(wxSdkUrl[`${getContext()}`], initSuccess);
                // } else {
                //     initSuccess();
                // }

                // 未加载成功,手动添加SDK，TODO：等发布优化后，再放开上面的判断
                return loadJS(wxSdkUrl[`${getContext()}`], initSuccess);
            } else {
                initSuccess();
            }
        } catch (error) {
            console.error(`【weblog-wx】初始化异常：${error}`);
        }
    }

    // 更新初始化参数
    updateInitParams(params: InitParams) {
        this.initParams = {
            ...this.initParams,
            ...params
        };
    }

    // 清除队列: 环境成功之后，发送队列中的数据
    queueReport() {
        // 防止密集型请求，导致请求被拦截
        let timer = setInterval(() => {
            if (this.queue.length() > 0) {
                let reportData: ReportParams = this.queue.dequeue();
                this.report(reportData);
            } else {
                clearInterval(timer);
            }
        }, 20);
    }

    // 数据上报
    report(params: ReportParams) {
        try {
            // getPageType：vue router meta 中传递的log参数获取
            const routerParams = getPageType();

            // 合并 params、routerParams、this.initParams
            const reportParams: ReportParams = splitParams({
                ...this.initParams,
                ...routerParams,
                ...params
            });

            // 根据当前环境，调用对应的端上报埋点
            platforms[getContext()](reportParams);
        } catch (error) {
            console.error(`【weblog-wx】埋点上报异常：${error}`);
        }
    }

    /**
     * 点击事件上报
     * @param actionType
     * @param params pageType, options, params, p1 ~ p8
     * @returns
     */
    clickLog(actionType: string, params: ClickParams) {
        try {
            if (!actionType || !isString(actionType) || !isSussKey(actionType)) {
                throw new Error('actionType必填！');
            }
            // 根据初始化状态决定直接上报还是加入队列
            this.initStatus ? this.report({ ...params, actionType }) : this.queue.add({ ...params, actionType });
        } catch (error) {
            console.error(`【weblog-wx】埋点上报异常：${error}`);
        }
    }
}
